class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.boundClose = this.close.bind(this);
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.boundClose);
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    } else {
      this.setActiveElement(null);
    }
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // Kapanış sırasında bekleyen "kilidi aç" işlemi varsa iptal et (hızlı kapat-aç durumu).
    clearTimeout(this.unlockTimer);

    // Sayfa kaydırma kilidi (html/body overflow + stil yeniden hesaplama) pahalı bir iştir ve eskiden
    // çekmecenin kayma animasyonuyla AYNI karede yapılıyordu → animasyonun ilk kareleri takılıyordu.
    // Şimdi kilit bir kare önce uygulanır, animasyon (active sınıfı) ondan sonraki karede başlar.
    // Çekmece henüz görünmediği için bu 1 karelik gecikme gözle fark edilmez.
    if (window.UniversalScrollLock) {
      window.UniversalScrollLock.lock();
    }
    // here the animation doesn't seem to always get triggered. rAF ensures
    // the class is added on the next paint frame, right before the transition runs.
    const openToken = (this.openToken = {});
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Bu iki kare içinde close() çağrıldıysa (veya yeni bir open() başladıysa) bu açılışı iptal et.
        if (this.openToken !== openToken) return;
        this.classList.add('animate', 'active');
        if (window.UniversalScrollLock) {
          window.UniversalScrollLock.sync();
        }
      });
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();

    // NOT: Burada eskiden her açılışta çekmecenin tamamı fiyat dönüştürme taramasından geçiriliyordu
    // (translateElementTree). Sepet içeriği değişmediyse bu tarama gereksizdi ve çekmece açılırken
    // ana iş parçacığını meşgul ediyordu. İçerik değiştiğinde (renderContents) tarama zaten yapılıyor;
    // sayfa yüklenirken ve para birimi değişince de tüm sayfa taranıyor.
    if (typeof window.updateCartDrawerRewardsBar === 'function') {
      window.updateCartDrawerRewardsBar();
    }
  }

  close() {
    this.openToken = null;
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    // Kaydırma kilidini kapanış animasyonu BİTTİKTEN sonra aç. Eskiden kilit, çekmece daha kayarken
    // açılıyor ve tüm sayfanın stil/yerleşim hesabı animasyonun ortasına denk geliyordu.
    // (Kilit sınıfı html/body üzerinde kaldığı için bu sürede sayfa zaten kilitli kalır.)
    clearTimeout(this.unlockTimer);
    this.unlockTimer = setTimeout(() => {
      if (window.UniversalScrollLock) {
        window.UniversalScrollLock.sync();
      }
    }, 480);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.contains('is-empty') && this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (window.GlobalLocalization) {
      window.GlobalLocalization.translateElementTree(this, window.GlobalLocalization.getLanguage());
    }
    if (typeof window.updateCartDrawerRewardsBar === 'function') {
      window.updateCartDrawerRewardsBar();
    }

    requestAnimationFrame(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

